import { render, staticRenderFns } from "./BusinessPage.vue?vue&type=template&id=5c0c6b03&scoped=true&"
import script from "./BusinessPage.vue?vue&type=script&lang=js&"
export * from "./BusinessPage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPage.vue?vue&type=style&index=0&id=5c0c6b03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c6b03",
  null
  
)

export default component.exports